module.exports = __webpack_public_path__ + "img/w26b.9d0a64bf.jpg";